import React, { useEffect, useState } from 'react';
import classes from "./LoginScreen.module.css";
import {
    loadCaptchaEnginge,
    LoadCanvasTemplate,
    validateCaptcha
} from "react-simple-captcha";
import { toast } from 'react-toastify';
import { loginApi } from '../http/http';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials } from '../store/slices/credentialsSlice';

const LoginScreen = () => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    // const [captcha, setCaptcha] = useState("");
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { credentials } = useSelector(state => state.credentialsSlice);


    useEffect(() => {
        if (credentials?.token) {
            navigate("/home");
        }
    }, []);

    //  if (validateCaptcha(captcha) === true) {
    //   alert("Captcha Matched!");
    //   setUserInput("");
    //   loadCaptchaEnginge(6);
    // }

    const handleFormSubmission = async (e) => {
        e.preventDefault();
        try {
            // if (!username || !password || !captcha) {
            if (!username || !password) {
                return toast.error("Please fill all the required fields in the form!");
            }
            // if (username?.trim().length <= 0 || password?.trim().length <= 0 || captcha?.trim().length <= 0) {
            if (username?.trim().length <= 0 || password?.trim().length <= 0) {
                return toast.error("Please fill all the required fields in the form!");
            }

            // if (validateCaptcha(captcha) === true) {
            setLoader(true);
            const response = await loginApi({ username, password });
            console.log(response.data);
            // token,client_id,client_username
            dispatch(setCredentials(response?.data));
            // Cookies.set("credentials",JSON.stringify(response?.data),{expires:6});
            toast.success(response?.data?.message);
            setLoader(false);
            navigate("/home");
            return;
            // }

            // toast.error("Invalid Captcha!");

        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data || error?.response?.data?.message || "Something Went Wrong!");
        }
    }


    return (
        <div className={classes.container}>
            <div className={classes.grid_items}>
                <div className={classes.grid_item}>
                    <div className={classes.girl_image_container}>
                        <img src="/assets/images/girl_on_desktop.svg" alt="girl on desktop" className={classes.girl_image} />
                    </div>

                    <img src="/assets/images/circle_1.svg" alt="circle" className={classes.circle1} />
                    <img src="/assets/images/circle_2.svg" alt="circle" className={classes.circle2} />
                    <img src="/assets/images/dots_1.svg" alt="dots" className={classes.dots1} />
                    <img src="/assets/images/dots_2.svg" alt="dots" className={classes.dots2} />
                    {/* <img src="/assets/images/line.svg" alt="line" className={classes.line} /> */}
                </div>
                <div className={classes.grid_item}>
                    <div className={classes.form_container}>
                        <div className={classes.logo_container}>
                            <img src="/assets/images/rainboo-logo-bg.png" alt="logo" className={classes.logo} />
                        </div>
                        <p className={classes.text_title}>Welcome Back</p>
                        <form className={classes.form} onSubmit={handleFormSubmission}>
                            <div className={classes.input_wrapper}>
                                <label htmlFor="username" className={classes.label}>
                                    User Name
                                </label>
                                <input required type="text" name="username" placeholder="Username"
                                    value={username}
                                    onChange={e => setUsername(e.target.value)}
                                    className={classes.input_form} />
                            </div>

                            <div className={classes.input_wrapper}>
                                <label htmlFor="password" className={classes.label}>
                                    Password
                                </label>
                                <input required type="password" name="password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    placeholder="Password" className={classes.input_form} />
                            </div>

                            {/* <div className={classes.input_wrapper}>
                                <label htmlFor="security" className={classes.label}>
                                    Security Text
                                </label>
                                <div className={classes.wrapper}>
                                    <input required type="text" name="security" placeholder="Security Text"
                                        value={captcha}
                                        onChange={e => setCaptcha(e.target.value)}
                                        className={classes.input_form} />
                                    <div className={classes.captcha_box}>
                                        <LoadCanvasTemplate />
                                    </div>
                                </div>
                            </div> */}

                            <button type="submit" className={classes.login_button} disabled={loader}>
                                {loader ?
                                    <div className={classes.center_loader}>
                                        <Spinner width={"24px"} height={"24px"} border={"6px"} />
                                    </div>
                                    : " Log in"}
                            </button>

                        </form>
                        <p className={classes.copyright}>© Rainboo Softmate Pvt Ltd {new Date().getFullYear()}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginScreen